var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5.5,
    stroke: "#9AB400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00931 6.008C7.84398 6.008 7.70531 5.952 7.59331 5.84C7.48131 5.728 7.42531 5.58933 7.42531 5.424C7.42531 5.25867 7.48131 5.12 7.59331 5.008C7.70531 4.896 7.84398 4.84 8.00931 4.84C8.16931 4.84 8.30531 4.896 8.41731 5.008C8.52931 5.12 8.58531 5.25867 8.58531 5.424C8.58531 5.58933 8.52931 5.728 8.41731 5.84C8.30531 5.952 8.16931 6.008 8.00931 6.008ZM8.45731 6.592V11H7.54531V6.592H8.45731Z",
    fill: "#9AB400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInformation);
export default __webpack_public_path__ + "static/media/ic_information.8146d5ee2e5c9ac12a116ddd02b654f0.svg";
export { ForwardRef as ReactComponent };